module.exports = __webpack_public_path__ + "media/images/illustrations/path-to-success-f73602e4b12e41511a497cb9a37f2706.svg";